import { Activity, AlertCircle, Bot, Check, Edit3, Eye, Lock, Users, X } from 'lucide-react';

export const USER_ROLES_FILTER = [
  { value: 'all', label: 'TODOS_LOS_ROLES', icon: Users },
  { value: 'admin', label: 'ADMIN', icon: Lock },
  { value: 'editor', label: 'EDITOR', icon: Edit3 },
  { value: 'viewer', label: 'VIEWER', icon: Eye },
  { value: 'agent', label: 'AGENT', icon: Bot },
];

export const USER_STATUSES_FILTER = [
  { value: 'all', label: 'TODOS_LOS_ESTADOS', icon: Activity },
  { value: 'active', label: 'ACTIVO', icon: Check },
  { value: 'inactive', label: 'INACTIVO', icon: X },
  { value: 'locked', label: 'SUSPENDIDO', icon: AlertCircle },
];

export const FORM_USER_ROLES = [
  { value: 'admin', label: 'ADMINISTRADOR', icon: Lock },
  { value: 'editor', label: 'EDITOR_CONTENIDO', icon: Edit3 },
  { value: 'viewer', label: 'LECTOR_DATOS', icon: Eye },
  { value: 'agent', label: 'AGENTE_IA', icon: Bot },
];

export const FORM_USER_STATUSES = [
  { value: 'active', label: 'ACTIVO', icon: Check },
  { value: 'inactive', label: 'INACTIVO', icon: X },
  { value: 'locked', label: 'SUSPENDIDO', icon: AlertCircle },
];
